import api from './api';
import { Necropolis, PaginatedResponse } from '../types';

export interface NecropolisFilters {
  page?: number;
  limit?: number;
  search?: string;
  rank?: string;
}

const necropolisService = {
  getList: async (filters: NecropolisFilters = {}): Promise<PaginatedResponse<Necropolis>> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    if (filters.rank) params.append('rank', filters.rank);
    const response = await api.get(`/necropolis?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<Necropolis> => {
    const response = await api.get(`/necropolis/${id}`);
    return response.data.data;
  },

  create: async (data: Omit<Necropolis, 'id' | 'createdAt' | 'updatedAt'>): Promise<Necropolis> => {
    const response = await api.post('/necropolis', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<Necropolis>): Promise<Necropolis> => {
    const response = await api.put(`/necropolis/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/necropolis/${id}`);
  },
};

export default necropolisService;